var exports = {
  "Qs": "xdde3148b--ffc628--content",
  "cL": "xdde3148b--ffc628--builder",
  "UU": "xdde3148b--ffc628--name",
  "qr": "xdde3148b--ffc628--footer",
};

module.exports = exports;
